import { render } from "./KeywordReplyModal.vue?vue&type=template&id=71f4618c&scoped=true"
import script from "./KeywordReplyModal.vue?vue&type=script&lang=js"
export * from "./KeywordReplyModal.vue?vue&type=script&lang=js"

import "./KeywordReplyModal.vue?vue&type=style&index=0&id=71f4618c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f4618c"]])

export default __exports__